import {Component, ElementRef, ViewChild} from '@angular/core';
import {debounce} from 'lodash-es';
import {SearchStore} from '../search.store';

@Component({
  selector: 'app-trainings-search',
  templateUrl: './trainings-search.component.html',
  styleUrls: ['./trainings-search.component.scss'],
})
export class TrainingsSearchComponent {
  // for setting focus
  @ViewChild('searchfield') searchfield?: ElementRef;

  private readonly _debounceSearch = debounce((value: string) => this._searchStore.setSearchTerm(value), 300);

  readonly searchTerm$ = this._searchStore.searchTerm$;
  readonly isSearch$ = this._searchStore.isSearch$;

  constructor(private readonly _searchStore: SearchStore) {}

  search(input: string) {
    this._debounceSearch(input);
  }

  clearSearch() {
    // triggered by the 'delete'-button in the input
    this._searchStore.setSearchTerm('');
  }
}
